export var Map = class {
  /**
   * Ready to work with the map.html include - wrap it with a div and pass its reference.
   *
   * Pointer options can describe the used pin "version" ('small' or 'big', 'big' is the default) and
   * the used default "color".
   */
  constructor(mapElement) {
    this.element = mapElement
    this.svg = mapElement && mapElement.querySelector('svg')

    // highlighting many things many times is DOM-heavy,
    // hence we keep an im memory cache of already fetched
    this.zipCache = {}
  }

  highlightZipCodeAreas(zipCodes) {
    let elements = []
    let missingElementSelector = []
    let tempEl

    let highlight = function (element) {
      element.style.fill = '#E9F3E2'
      element.style.fillOpacity = 0.75
    }

    for (var zipCode of zipCodes) {
      if (this.zipCache.id) {
        elements.push(this.zipCache.id)
      } else {
        missingElementSelector.push('[data-zip="' + zipCode + '"]')
      }
    }

    elements.forEach(highlight)
    if (missingElementSelector.length > 0) {
      var missingElements =
        (this.svg &&
          this.svg.querySelectorAll(missingElementSelector.join(','))) ||
        []
      for (var i = missingElements.length; (tempEl = missingElements[--i]); ) {
        this.zipCache[tempEl.id] = tempEl
        highlight(tempEl)
      }
    }
  }
}
